import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

const api = axios.create({
  baseURL: API,
  // Some corporate networks + certain browsers aggressively cache GET responses,
  // which produced the "different data on different systems" complaint. Explicitly
  // tell every layer not to reuse a stale response.
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
  timeout: 45000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.includes("login")) {
      const isClient = localStorage.getItem("crm_kind") === "client";
      localStorage.removeItem("crm_token");
      localStorage.removeItem("crm_user");
      localStorage.removeItem("crm_kind");
      window.location.href = isClient ? "/client-login" : "/login";
    }
    return Promise.reject(err);
  },
);

export default api;
